var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1111 0H0V15.3418H1.36289V19.75H33.7482V15.3418H35.1111V0ZM32.9383 18.9378H2.1728V15.3418H4.53551V17.6215H5.90957V15.3418H7.28363V17.6215H8.65769V15.3418H10.0317V17.6215H11.4058V15.3418H12.7799V17.6215H14.1539V15.3418H15.528V17.6215H16.902V15.3418H18.2649V17.6215H19.639V15.3418H21.013V17.6215H22.3871V15.3418H23.7612V17.6215H25.1352V15.3418H26.5093V17.6215H27.8722V15.3418H29.2462V17.6215H30.6203V15.3418H32.9383V18.9378ZM34.3012 14.5296H33.7482H1.36289H0.809913V0.80658H34.3012V14.5296Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96479 3.06396H3.34009V12.2052H8.97037V3.06396H8.96479ZM8.15488 11.393H4.14441V3.87054H8.15488V11.393Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9746 3.06396H11.3499V12.2052H16.9802V3.06396H16.9746ZM16.1647 11.393H12.1542V3.87054H16.1647V11.393Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9843 3.06396H19.3596V12.2052H24.9899V3.06396H24.9843ZM24.1744 11.393H20.1639V3.87054H24.1744V11.393Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8157 3.06396H28.5984V8.04347H31.8157V3.06396ZM31.0058 7.22569H29.4027V3.87054H31.0058V7.22569Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRam);
export default __webpack_public_path__ + "static/media/ram.21a4958e67a384de4f3e314e2e2bfa27.svg";
export { ForwardRef as ReactComponent };